import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie"; // Import js-cookie for handling cookies
import { sendPictures } from "../api/code"; // Adjust the import path as needed

// Async thunk to send pictures
export const sendPicture = createAsyncThunk(
  "pictures/sendPicture",
  async ({ image }, { rejectWithValue }) => {
    try {
      console.log("imageInsideThunk", image);
      // Retrieve token from cookies
      // const token = sessionStorage.getItem("token");
      const userKioskToken = Cookies.get("user_kiosk_token");

      if (!userKioskToken) throw new Error("User token is missing");

      const response = await sendPictures({ image, userKioskToken });
      return response.data; // Return the response data on success
    } catch (error) {
      // Reject with error response or message
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: null,
};

const sendPictureSlice = createSlice({
  name: "sendPicture",
  initialState,
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendPicture.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = null;
      })
      .addCase(sendPicture.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = null;
      })
      .addCase(sendPicture.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = action.payload || "Failed to send picture";
      });
  },
});

export const { resetState } = sendPictureSlice.actions;

export const sendPictureReducer = sendPictureSlice.reducer;
